module.exports = __webpack_public_path__ + "src/img/toTopTips.f970734f.png";